import axios from "axios";
import { firestore, getFullHttpUrl } from "../../firebase.config";
import { EAST1, EAST4 } from '../../utility/enums';
import authHeaders from '../../utility/authHeaders';
import { payKind } from "../../utility/payments";

export const updateInvoiceClientName = async(orderInfo, clientFirstName, clientLastName, caseNumber = "") => {
  if(!orderInfo || !orderInfo.orderInvoiceId || 
    (orderInfo.orderInvoiceType && orderInfo.orderInvoiceType  === "multipleInvoice")){
      return;
  }

  await firestore.collection("orderInvoices").doc(orderInfo.orderInvoiceId).update({
    clientFirstName, clientLastName, caseNumber
  });
}

export const capitalizeText = value => {
    if(value.length > 1){
    const array = value.split(" ");
    const capitalizeWordArray = array.map(data => {
      if(data.length > 1){
        return data.slice(0,1).toUpperCase() + data.slice(1,-1) + data.slice(-1)
      }
      return data.toUpperCase();
    });
    return capitalizeWordArray.join(" ");
    }else{
      return value.toUpperCase();
    }
  }

 export const getDue = (returnDueMilliseconds,order, pagesCount, certified, expedited, expeditedPlus) => {
    let limits = [0, 750];

    for (let i = 2; i < 200; i++) {
      limits.push(limits[limits.length - 1] + 1500 + (i - 2) * 250);
    }

    let count = 0;

  const orderDate = order && order.timestamp ? new Date(order.timestamp) : new Date();
  const standardTransUpdate = new Date('Sun, 6 Dec 2024 10:02:56 GMT');

    if (orderDate > standardTransUpdate) {
      if (order) {
        if (pagesCount || order.pagesCount !== "") {
          count = (pagesCount ? pagesCount : order.pagesCount) * 250;
        }
      }
      } else {
        if (certified || (order && order.certified)) {
          if (pagesCount || order.pagesCount !== "") {
            count = (pagesCount ? pagesCount : order.pagesCount) * 250;
          } 
        } else {
          if (pagesCount || order.wordCount !== "") {
            count = pagesCount ? pagesCount : order.wordCount;
          }
        }
    }

    const ceiling = limits.filter(limit => count <= limit).sort((a, b) => a - b)[0];
    let ceilingIndex = limits.findIndex(limit => limit === ceiling);

    if (expedited || order.expedited) {
      ceilingIndex = ceilingIndex / 2;
    }
    if (expeditedPlus || order.expeditedPlus) {
      ceilingIndex = ceilingIndex * 0.1667;
    }

    // if (ceilingIndex > 0.5) {
    //   ceilingIndex = Math.ceil(ceilingIndex);
    // }

    let miliseconds = ceilingIndex * 24 * 60 * 60 * 1000;

    const now = new Date();

    const dueMiliseconds = now.getTime() + miliseconds;

    if(returnDueMilliseconds){
      return dueMiliseconds;
    }

     if ( ceilingIndex <= 2) {
      return `${Math.round(ceilingIndex * 24)} hours`;
    } else {
      return `${Math.round(ceilingIndex - 1)}-${Math.round(ceilingIndex)} days`;
    }

  }

export const getClients = async (userData, setClients, getAll = "all") => {

  let clientsMap = new Map();

  const checkClientName = (data) => {
    const clientName = (data.clientFirstName + " " + data.clientLastName).toLowerCase();

    if(clientsMap.has(clientName)){
      const number = clientsMap.get(clientName);
      clientsMap.delete(clientName);
      clientsMap.set(clientName, number + 1);
    }else{
      clientsMap.set(clientName, 1);
    }
  }

  if(getAll === "order" || getAll === "all"){
    const ordersSnap = await firestore
          .collection("orders")
          .where("teamId", "==", userData.teamId)
          .get();

    !ordersSnap.empty && ordersSnap.docs.filter(o => o.data().clientFirstName).map((doc) => checkClientName(doc.data(), "orders"));
    
  }

  if(getAll === "quote" || getAll === "all"){

   const quotesSnap = await firestore
          .collection("quotes")
          .where("teamId", "==", userData.teamId)
          .get();

    !quotesSnap.empty && quotesSnap.docs.filter(o => o.data().clientFirstName).map((doc) => checkClientName(doc.data(), "quotes")) ;

  }

  const clientsArray = [];
  clientsMap.forEach((value, key) => {
    clientsArray.push({name: key, count: value})
  })

  const sortedClients = clientsArray.sort((a,b) => a.name > b.name ? 1 : -1);
  setClients(sortedClients);
}

// The Stripe customer that getClientSecret puts on a new PaymentIntent. The
// server only adds setup_future_usage (save the card) when there is one, and
// only accepts one of the signed-in account's own customers (EV-250).
export const getPaymentCustomerId = (userData, teamData, paymentCardId = false) =>
  userData ? userData.teamId
    ?  teamData ? paymentCardId ? teamData.paymentMethods.find(m => m.id === paymentCardId).customer : teamData.stripeCustomerId : ""
    : paymentCardId ? userData.paymentMethods.find(m => m.id === paymentCardId).customer : userData.stripeCustomerId : "";

// discountCode: the code applied at checkout ("" if none). With `kind` the
// server prices what is paid and payments-confirm checks the payment against
// it later (EV-242).
export const getClientSecret = async (type, item, number, email, amount, id, userData, teamData, paymentCardId = false, futurePayment =true, discountCode = "") => {
  const reciept_email = userData && userData.teamId && checkAutoBilling(teamData) ? await getTeamOwnerEmail(userData.teamId) : email;
  const client_name = item && item.clientFirstName ? ` \nYour Client: ${item.clientFirstName} ${item.clientLastName ?? ""}` : "";
  const capitalizeType = type ? capitalizeText(type) : "";
  const data = {
        amount: get2DecimalNumber(amount),
        orderId: id,
        customerId: getPaymentCustomerId(userData, teamData, paymentCardId),
        futurePayment: futurePayment,
        email: reciept_email ?? email,
        description: (number ? `${capitalizeType ?? ""} Number: #${number}` : "") + (client_name ?? ""),
        kind: payKind(type),
        ...(discountCode ? { discountCode } : {}),
      }
    // The sign-in token lets the function check the customer is this
    // account's; guests send none and pay without a customer.
    const res = await axios({
      method: "post",
      url: getFullHttpUrl("stripe-createPaymentIntent"),
      data: data,
      headers: await authHeaders(),
    });

    return res.data.client_secret;
  };

export const getTeamOwnerEmail = async(teamId) => {
  const usersSnap = await firestore.collection("users").where("teamId", "==", teamId).where("teamRole", "in", ["owner", "admin"])
  .orderBy("teamJoinTimestamp", "asc").get();
  if(usersSnap.empty){
    return false;
  }

  return usersSnap.docs[0].data().email;
}

export const checkNotUndefinedValue = (value) => {
  return typeof(value) === "undefined" ? false : true;
}

export const get2DecimalNumber = (value) => {
  return Number(parseFloat(value).toFixed(2));
}

export const checkAutoBilling = (teamData) => {
  if (teamData && teamData.billingTerm && teamData.billingTerm !== "case-by-case") {
    return true;
  } else {
    return false;
  }
}

export const getShortOrderNo = (number, type = "order") => {
    if(!number) return  "";
    if (number.toString().length > 12) {
      return ".." + number
        .toString()
        .split(type === "order" ? "23400000" : "266000000")[1];
    }
    return number;
  };

export const formatDiscount = (value) => "-$" + parseFloat(value).toFixed(2);

export const formatTotal = (value) => {
      return "$" + parseFloat(value).toFixed(2);
    }; 

export const signaturePrice = (requireSignature, orderInfo) => {
  if (requireSignature) {
    if (new Date(orderInfo.timestamp) >= new Date('Sun, 30 Oct 2022 20:02:56 GMT')) {
      return 4.99;
    } else {
      return 2.54;
    }
  } else {
    return 0
  }
}

export const getHardCopyPrice = (country, hardCopyMethod, hardCopyRequireSignature, order) => {
  if (country === '' || hardCopyMethod === '') {
    return 0;
  }

  const orderDate = order && order.timestamp ? new Date(order.timestamp) : new Date();
  const priceUpdateDate = new Date('Sun, 30 Oct 2022 20:02:56 GMT');

  const price = (orderDate >= priceUpdateDate) ?
    ['United States', 'Puerto Rico', 'U.S. Virgin Islands'].includes(country)
      ? (hardCopyMethod === 'priority' ? 19.95 : 37.95) : (hardCopyMethod === 'priority' ? 49.95 : 78.95)
    : ['United States', 'Puerto Rico', 'U.S. Virgin Islands'].includes(country) ? (hardCopyMethod === 'priority' ? 12.95 : 29.95)
      : (hardCopyMethod === 'priority' ? 39.95 : 67.95);

  if (hardCopyRequireSignature) {
    if (orderDate >= priceUpdateDate) {
      return (price + 4.99);
    } else {
      return (price + 2.54);
    }
  } else {
    return price;
  }
}

// The cheapest hard copy today (USPS Priority within the US), shown as "from
// $19.95" until the customer picks the country and the shipping method.
export const hardCopyFromPrice = () => getHardCopyPrice('United States', 'priority', false);

// Language pairs without English (Alejo, 8 Oct 2026): $34.95 a page instead
// of $24.95, for certified and standard translations alike. Expedited is a
// share of the page total and the discount applies to it, so both follow.
// Orders and quotes from before the change keep the price they had (two
// delivered orders had such a pair, at $24.95). The functions price with the
// same rule (functions PriceCalculate), and so does the public API.
export const PAGE_PRICE = 24.95;
export const NON_ENGLISH_PAGE_PRICE = 34.95;
const nonEnglishPriceUpdate = new Date('Thu, 8 Oct 2026 00:00:00 GMT');

const isEnglish = (language) => String(language || '').trim().toLowerCase() === 'english';

// Both languages chosen and neither is English.
export const isNonEnglishPair = (languageFrom, languageTo) => Boolean(languageFrom) && Boolean(languageTo) && !isEnglish(languageFrom) && !isEnglish(languageTo);

// The price of a page of this order or quote (its languageFrom/languageTo), or
// the one office set on the quote (pagePrice: a translator certified by ATA,
// feedback 1-nov), which the quote's order keeps. Same in functions PriceCalculate.
export const getPagePrice = (order) => {
  if (order && Number(order.pagePrice) > 0) {
    return Number(order.pagePrice);
  }
  const orderDate = order && order.timestamp ? new Date(order.timestamp) : new Date();
  return order && isNonEnglishPair(order.languageFrom, order.languageTo) && orderDate >= nonEnglishPriceUpdate
    ? NON_ENGLISH_PAGE_PRICE
    : PAGE_PRICE;
};

// What expedited adds per page, as the delivery options show it: "$4.99"
// (20%) and "$9.98" (40%) for $24.95 pages, "$6.99" and "$13.98" for $34.95.
export const getExpeditedPerPage = (order, expeditedPlus = false) => formatTotal(getPagePrice(order) * (expeditedPlus ? 0.4 : 0.2));

// "3 pages × $34.95", for the lines of summaries and invoices.
export const pagesTimesPrice = (order) => {
  const pages = parseInt(order && order.pagesCount, 10) || 0;
  return `${pages} page${pages === 1 ? '' : 's'} × ${formatTotal(getPagePrice(order))}`;
};

export const getOrderPageCountTotal = (order, count = false, certified = false) => {
  const standardTransUpdate = new Date('Sun, 6 Dec 2024 10:02:56 GMT');
  const orderDate = order && order.timestamp ? new Date(order.timestamp) : new Date();
  let total = 0;
  if (orderDate > standardTransUpdate) {
    if (order) {
      if (count || order.pagesCount !== "") {
        total = total + parseInt(count ? count : order.pagesCount, 10) * getPagePrice(order);
      } else {
        total = 0;
      }
    }
  } else {
    if (certified || (order && order.certified)) {
      if (count || order.pagesCount !== "") {
        total = total + parseInt(count ? count : order.pagesCount, 10) * 24.95;
      } else {
        total = 0;
      }
    } else {
      if (count || order.wordCount !== "") {
        total = total + parseInt(count ? count : order.wordCount, 10) * 0.1;
      } else {
        total = 0;
      }
    }
  }

  return total;

}

// An interpretation quote (office's Interpretations) costs what office priced
// it at, with no discount: it has no pages. Same as the functions' getTotal.
export const isInterpretation = (order) => Boolean(order) && order.service === "interpretation";

export const getDiscount = (order, count = false, discount = false, certified = false) => {
  // if(order && order.translationPrice) {
  //   return (order.translationPrice * (discount ? discount : order.discount)) / 100;
  // }
  if (isInterpretation(order)) {
    return 0;
  }
  if (!count && (order.pagesCount === undefined && order.wordCount === undefined)) {
    return 0; 
  } else if ((!discount || discount === 0) && (!order || !order.discount || order.discount === 0)) {
    return 0;
  } else {
    const orderDate = order && order.timestamp ? new Date(order.timestamp) : new Date();
    const discountUpdateDate = new Date("Tue, 28 Mar 2023 20:02:56 GMT");

    if (orderDate >= discountUpdateDate) {
      let total = 0;

      total = total + getOrderPageCountTotal(order, count, certified);

      return (total * (discount ? discount : order.discount)) / 100;
    }
    return (getTotal(order, count, certified) * (discount ? discount : order.discount)) / 100;
  }
};



export const getExpedited = (order, count = false, expeditedPlus = false, expedited = false, certified = false, expeditedServiceOption) => {
  const orderDate = order && order.timestamp ? new Date(order.timestamp) : new Date();
  const priceUpdateDate = new Date('Sun, 30 Oct 2022 20:02:56 GMT');
  const expeditedPlusUpdate = new Date('Sun, 6 Dec 2024 10:02:56 GMT');
  let total = 0;

  total = total + getOrderPageCountTotal(order, count, certified);

  if(expeditedServiceOption === "free-plus" || (order && order.expeditedServiceOption === "free-plus")){
    return 0;
  };


  if (expeditedPlus || (order && order.expeditedPlus)) {
    return total * 0.4;
  } else if (expedited || (order && order.expedited)) {

    if(expeditedServiceOption === "free" || (order && order.expeditedServiceOption === "free")){
      return 0;
    };

    if (orderDate > expeditedPlusUpdate) {
      return total * 0.2;
    } else {
      if (orderDate > priceUpdateDate) {
        return total * 0.4
      } else {
        return total * 0.6;
      }
    }

  }

  return 0;
}

export const getTotal = (order, count = false, certified = false, notrization, expedited, expeditedPlus, hardCopy, hcopyCountry, hcopyMethod, hcopySignature, expeditedServiceOption) => {
  // if(order.totalPrice){
  //   return order.totalPrice;
  // }
  if (isInterpretation(order)) {
    return Number(order.totalPrice) || 0;
  }
  if (!count && (order.pagesCount === undefined && order.wordCount === undefined)) {
    return 0;
  }

  let total = 0;

  total = total + getOrderPageCountTotal(order, count, certified);

  total = total + getExpedited(order, count, expeditedPlus, expedited, certified, expeditedServiceOption);

  if (checkNotUndefinedValue(notrization)) {
    if(notrization){
      total = total + 34.90;
    }
  }else if(order && order.notarization){
    total = total + 34.90;
  }

  if (checkNotUndefinedValue(hardCopy)) {
    if(hardCopy){
      total = total + getHardCopyPrice(hcopyCountry, hcopyMethod, hcopySignature);
    }
  }else if(order && order.hardCopy) {
    total = total + getHardCopyPrice(
        order.hardCopyExtra.country,
        order.hardCopyExtra.method,
        order.hardCopyExtra.requireSignature, order);
  }

  // Additional payments office asked for after the order was placed, for the
  // part the order's own fields don't price (functions ExtraCharges/core.js;
  // can be negative). Same as the functions' getTotal.
  total = total + getExtraChargesTotal(order);

  return total;
};

export const getExtraChargesTotal = (order) => {
  const value = order ? Number(order.extraChargesTotal) : 0;
  return Number.isFinite(value) ? value : 0;
};

export const getTotalQuote = (quote, count = false, certified = false, notrization, expedited, expeditedPlus, hardCopy, hcopyCountry, hcopyMethod, hcopySignature, expeditedServiceOption = "paid") => {
  if (!count && (quote.pagesCount === undefined && quote.wordCount === undefined)) {
    return 0;
  }

  let total = 0;

  total = total + getOrderPageCountTotal(quote, count, certified);


  total = total + getExpedited(quote, count, expeditedPlus, expedited, certified, expeditedServiceOption);


   if (checkNotUndefinedValue(notrization)) {
    if(notrization){
      total = total + 34.90;
    }
  }else if(quote && quote.notarization){
    total = total + 34.90;
  }

  if (checkNotUndefinedValue(hardCopy)) {
    if(hardCopy){
      total = total + getHardCopyPrice(hcopyCountry, hcopyMethod, hcopySignature);
    }
  }else if(quote && quote.hardCopy) {
    total = total + getHardCopyPrice(
        quote.hardCopyExtra.country,
        quote.hardCopyExtra.method,
        quote.hardCopyExtra.requireSignature, quote);
  }

  return total;
};
export const sendNotification = async (notification) => {
  try {
    const response = await axios({
      method: "post",
      url: getFullHttpUrl("notification-sendNotificationToClients", EAST1),
      data: notification,
      headers: await authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error sending notification:", error.response?.data || error.message);
    throw error;
  }
};
export const markAllNotificationsAsRead = async (userId) => {
  try {
    const response = await axios({
      method: "post",
      url: getFullHttpUrl("notification-markNotificationsAsRead", EAST4),
      data: { type: "ALL", userId },
      headers: await authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error marking notifications as Read:", error.response?.data || error.message);
    throw error;
  }
};
export const markNotificationAsRead = async (notificationId, userId) => {

  const ids = Array.isArray(notificationId) ? notificationId : [notificationId];
  console.log('ids', ids);
  
  try {
    const response = await axios({
      method: "post",
      url: getFullHttpUrl("notification-markNotificationsAsRead", EAST4),
      data: { notificationIds: ids, userId, type: "SingleOrBatch" },
      headers: await authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error marking notifications as Read:", error.response?.data || error.message);
    throw error;
  }
};
export const updateNotificationStatus = async (notificationId) => {
  try {
    const response = await axios({
      method: "post",
      url: getFullHttpUrl("notification-updateScheduledNotification", EAST4),
      data: { notificationId }
    });
    return response.data;
  } catch (error) {
    console.error("Error update notification status:", error.response?.data || error.message);
    throw error;
  }
};
export const updateNotification = async (notificationId, data) => {
  try {
    const response = await axios({
      method: "post",
      url: getFullHttpUrl("notification-updateNotification", EAST4),
      data: { notificationId, data },
      headers: await authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error update notification status:", error.response?.data || error.message);
    throw error;
  }
};
export const incrementViewCount = async (notifIds, userId) => {
  try {
    const response = await axios({
      method: "post",
      url: getFullHttpUrl("notification-updateNotificationStats", EAST4),
      data: { notifId : notifIds, type: "view", userId },
      headers: await authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Failed to increment view count", error);
  }
};
export const incrementClickCount = async (notifIds, userId) => {
  try {
    const response = await axios({
      method: "post",
      url: getFullHttpUrl("notification-updateNotificationStats", EAST4),
      data: { notifId : notifIds, type: "click" , userId},
      headers: await authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Failed to increment click count", error);
  }
};

export const getExpeditedFeeOption = (userData, teamData) => {

  if(userData && userData.teamId && teamData){

    // if(teamData.freeExpeditedOrders && teamData.freeExpeditedOrders > 0){
    //   return "free-plus";
    // }
    if(teamData.expeditedServices){
      return teamData.expeditedServices;
    }
  }

  return "paid";

}

// `order`: the order or quote (its language pair sets the price of a page).
export const getExpeditedPriceLabel = (expeditedPlus = false, userData, teamData, order = null) => {

  if(userData && userData.teamId && teamData){
    // if(teamData.freeExpeditedOrders && teamData.freeExpeditedOrders > 0){
    //   return "Free";
    // }
    if(teamData.expeditedServices){
      if(expeditedPlus && teamData.expeditedServices === "free-plus"){
          return "Free";

      }

      if(!expeditedPlus && (teamData.expeditedServices === "free-plus" || teamData.expeditedServices === "free")){
        return "Free";
      }
    }
  }

  return `${getExpeditedPerPage(order, expeditedPlus)}/page`;


}

export const getExpeditedFreeOrders = (userData, teamData) => {
  if(userData && userData.teamId && teamData){
    if(teamData.freeExpeditedOrders ){
      return teamData.freeExpeditedOrders;
    }
  }
  return 0;
}

export const decrTeamFreeExpedOrder = async(teamId) => {
      const docRef = firestore.collection("teams").doc(teamId);
      const teamDoc = await docRef.get();
      if(teamDoc.exists){
        const teamData = teamDoc.data();
        const freeOrders = teamData.freeExpeditedOrders || null;

        if(freeOrders && freeOrders > 0){
          const newFreeOrders = freeOrders - 1;

          docRef.update({freeExpeditedOrders: newFreeOrders, 
            expeditedServices: newFreeOrders > 0 ? "free-plus" : "paid"});
        }
      }
}

